export default {
    path: 'declare_list',
    component: () => import('@/pages/declareSetting/DeclareList'),
    meta: {title:'配置人资公司信息'},
	children: [
	]
}